import React from 'react';
const RadioHalf = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-video-off"
        {...props}
    >
        <circle cx="12" cy="12" r="2"></circle><path d="M 16.24 7.76 a 6 6 0 0 1 0 8.49 m -8.48 -0.01 a 6 6 0 0 1 0 -8.49 m -14.14 0"></path>

    </svg>
);


export default RadioHalf;





